import { createAction, props } from '@ngrx/store';
import { ActionErrorBase } from '../../models/object';

export const reduxDebugAction = createAction('[Redux] Redux Debug Action', props<{ message: string }>());

export enum GenericReduxActions {
  ReduxActionFail = '[Shared] Action Error',

  PurgeAllObjectErrors = '[Shared] Purge All Object Errors',
  ObjectNotFoundError = '[Shared] Object Not Found Error',
  ClearObjectSavingCounter = '[Shared] Clear Object Saving Counter',
  ClearAllObjectStates = '[Shared] Clear All Object States'
}

export const reduxActionFail = createAction(GenericReduxActions.ReduxActionFail, props<ActionErrorBase>());
export const purgeAllObjectErrors = createAction(GenericReduxActions.PurgeAllObjectErrors);
export const objectNotFoundError = createAction(GenericReduxActions.ObjectNotFoundError);
export const clearAllObjectStates = createAction(GenericReduxActions.ClearAllObjectStates);
